import { useContext } from 'react';
import { Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import SearchBar from '../../../components/SearchBar';
import { AuthStore } from '../../../providers/auth';
import { ModalManagementStore } from '../../../providers/modal-manager';
import { DASHBOARD_ROUTE } from '../../../routes/types';
import { getAllFooterData } from '../../../services/navigation';
import { DateFormats, formatDate } from '../../../utils/utils';

const Footer = () => {
  const [, , , selectedPersona] = useContext(AuthStore) || [];
  const { openModal } = useContext(ModalManagementStore);
  const navigate = useNavigate();
  const footerMenus = getAllFooterData(selectedPersona);

  return (
    <Container fluid className="m-0 p-0 w-100 cnd-footer mt-12">
      
      <div className="second-section py-11 px-10 px-lg-11 text-sub1 fw-light w-100 d-lg-flex flex-lg-row justify-content-lg-between">
        <div>
          <span>
            © {formatDate(new Date(), DateFormats.ONLY_YEAR)} Conduent Business
            Services, LLC All rights reserved.
          </span>
        </div>
        <div className="pt-10 pt-lg-0 d-flex flex-row">
          <div className="d-flex flex-column flex-lg-row">
            <span className="lh-xxs">Terms of Use</span>
            <span className="pt-3 pt-lg-0 ps-lg-10 lh-xxs">
              System Requirements
            </span>
          </div>
          <div className="ps-11 ps-lg-0 d-flex flex-column flex-lg-row">
            <span className="ps-lg-10 lh-xxs">Privacy Statement</span>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default Footer;
